<template>
  <div>
    <v-row dense class="mx-1">
      <v-btn v-if="hasModuleGerencia"
             color="primary"
             class="rounded-tag-small normal-btn-text elevation-0"
             link to="/cadastro-cotacao">
        <v-icon left>mdi-plus</v-icon>
        Cotação
      </v-btn>
      <v-btn v-if="hasModuleGerencia"
             color=""
             class="rounded-tag-small normal-btn-text ml-3 elevation-0"
             link to="/importar-cotacao">
        <v-icon left>mdi-file-import-outline</v-icon>
        Importar
      </v-btn>
      <v-spacer/>
      <v-btn icon @click="onClickRefresh">
        <v-icon left>mdi-refresh</v-icon>
      </v-btn>
      <px-listagem-cotacao-filtros @change="emitChange" />
      <px-search-text class="rounded-tag-small"
                      label="Busque por usuário, código ou identificador"
                      v-model="searchText"
                      style="max-width: 400px"
                      :on-search="emitChange"/>
    </v-row>
    <px-line-filter :options="statusOptions" v-model="selectedStatus"
                    :on-select-item="emitChange">
    </px-line-filter>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ListagemCotacaoFiltros from '@/modules/cotacao/listagem/ListagemCotacaoFiltros.vue';

export default {
  props: {
    onClickRefresh: {
      type: Function,
      required: true,
    },
  },
  methods: {
    emitChange() {
      this.$emit('change');
    },
  },
  data() {
    return {
      statusOptions: [
        {
          id: 'TODAS',
          description: 'Todas',
          value: null,
        },
        {
          id: 'RASCUNHO',
          description: 'Rascunhos',
          value: ['RASCUNHO'],
        },
        {
          id: 'ABERTAS',
          description: 'Abertas',
          value: ['ABERTA'],
        },
        {
          id: 'CANCELADAS',
          description: 'Canceladas',
          value: ['CANCELADA'],
        },
        {
          id: 'FINALIZADAS',
          description: 'Finalizadas',
          value: ['FINALIZADA'],
        },
      ],
    };
  },
  computed: {
    ...mapGetters('user', ['hasModuleGerencia']),
    selectedStatus: {
      get() {
        return this.$store.getters['listagemCotacao/selectedStatus'];
      },
      set(selectedStatus) {
        this.$store.dispatch('listagemCotacao/selectedStatus', selectedStatus);
      },
    },
    searchText: {
      get() {
        return this.$store.getters['listagemCotacao/searchText'];
      },
      set(searchText) {
        this.$store.dispatch('listagemCotacao/searchText', searchText);
      },
    },
  },
  created() {
    if (!this.selectedStatus) {
      [this.selectedStatus] = this.statusOptions;
    }
  },
  components: {
    pxListagemCotacaoFiltros: ListagemCotacaoFiltros,
  },
};
</script>
